module.exports = __webpack_public_path__ + "h5/static/img/coin-pro-down.b47415f4.png";